module.exports = __webpack_public_path__ + "img/IMG_6092.fba40c25.jpg";